import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { digitalApi } from '@/lib/digitalApi';
import { ArticleView } from '@/components/digital/ArticleView';
import { usePageMeta } from '@/lib/usePageMeta';
import { articleSchema } from '@/constants/seo';
import { formatMonthYear } from '@/constants/resourceSections';
import { PHOTOS } from '@/constants/content';
import { assetUrl } from '@/lib/digitalApi';

export default function JournalArticle() {
  const { slug } = useParams();
  const [entry, setEntry] = useState(undefined);
  const [list, setList] = useState([]);

  useEffect(() => {
    setEntry(undefined);
    digitalApi.get(slug, 'journal')
      .then((p) => setEntry(p.content_type === 'article' ? p : null))
      .catch(() => setEntry(null));
    digitalApi.list({ section: 'journal', content_type: 'article' }).then((d) => setList(d.items)).catch(() => setList([]));
  }, [slug]);

  const idx = list.findIndex((e) => e.slug === slug);
  const nextItem = entry && !entry.unlisted && idx >= 0 && list.length > 1 ? list[(idx + 1) % list.length] : null;

  usePageMeta(
    entry
      ? {
          title: `${entry.title} | Founder Journal | Toia Wallace`,
          description: entry.short_description,
          path: `/journal/${entry.slug}`,
          image: entry.cover_url ? assetUrl(entry.cover_url) : PHOTOS.editorial,
          ogType: 'article',
          jsonLd: articleSchema({ title: entry.title, dek: entry.short_description, date: formatMonthYear(entry.published_date), slug: entry.slug }),
          ...(entry.unlisted ? { robots: 'noindex, nofollow' } : {}),
        }
      : { title: 'Founder Journal | Toia Wallace', path: '/journal' },
  );

  if (entry === undefined) return <div className="bg-ivory min-h-[70vh] pt-56 text-center text-matte/50">Loading…</div>;
  if (!entry) {
    return (
      <div className="bg-ivory min-h-[70vh] pt-40 pb-24">
        <div className="mx-auto max-w-[900px] px-6 text-center">
          <div className="eyebrow text-taupe mb-6">Not Found</div>
          <h1 className="font-serif-display text-5xl text-matte">Entry not found</h1>
          <Link to="/journal" className="btn-ghost mt-10 inline-flex">
            <ArrowLeft size={14} strokeWidth={1.6} /> Return to Journal
          </Link>
        </div>
      </div>
    );
  }
  return (
    <ArticleView
      article={entry}
      backTo="/journal"
      backLabel="Founder Journal"
      next={nextItem && { ...nextItem, href: `/journal/${nextItem.slug}` }}
    />
  );
}
